const scienceFactoryCampZipCodes = [
  '07030',
  '07086',
  '07302',
  '07310',
  '10001',
  '10002',
  '10003',
  '10004',
  '10005',
  '10006',
  '10007',
  '10009',
  '10010',
  '10011',
  '10012',
  '10013',
  '10014',
  '10018',
  '10019',
  '10021',
  '10022',
  '10023',
  '10024',
  '10025',
  '10026',
  '10027',
  '10028',
  '10029',
  '10030',
  '10031',
  '10032',
  '10033',
  '10034',
  '10035',
  '60610',
  '60611',
  '60614',
  '60622',
  '60642',
  '60647',
  '60654',
  '60657',
  '60661',
  '98004',
  '98005',
  '98006',
  '98007',
  '98008',
  '98033',
  '98101',
  '98102',
  '98103',
  '98105',
  '98107',
  '98109',
  '98112',
  '98115',
  '98117',
  '98125',
  '98133',
  '98144',
  '98155',
  '98177',
];

export default scienceFactoryCampZipCodes;
